import * as React from "react";
import "./Legend.scss";
import { useVisibleValues } from "../Containers/VisibleValuesContext";
import { LegendRow } from "./LegendRow";
export const PrintableLegend = ({ hidden, legendContainerRef, legendProperties, objectProperties, minimal, height, showLabel, }) => {
    const { visibleValues } = useVisibleValues();
    const onlyVisibleValues = visibleValues
        ? Object.keys(visibleValues)
            .filter((key) => visibleValues[key])
            .reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: true })), {})
        : null;
    return !hidden ? (React.createElement("div", { ref: legendContainerRef, className: "printable-legend", style: { height } },
        visibleValues
            ? Object.keys(onlyVisibleValues).map((key) => {
                const { color, style, title, yId } = legendProperties[key];
                return (React.createElement(LegendRow, { key: key, minimal: minimal, legendValue: true, legendDescription: title, legendLineStyle: style.lineStyle, legendSymbol: style.symbol, color: color, toggleVariable: () => { }, yId: yId, showLabel: showLabel }));
            })
            : null,
        objectProperties && Object.keys(objectProperties).length > 0
            ? Object.keys(objectProperties).map((objectKey) => {
                const { color, title, lineStyle } = objectProperties[objectKey];
                return (React.createElement(LegendRow, { key: objectKey, minimal: minimal, legendValue: true, legendDescription: title, legendLineStyle: lineStyle, color: color }));
            })
            : null)) : null;
};
//# sourceMappingURL=PrintableLegend.js.map